<template>
	<auth-layout>
		<v-responsive min-height="100vh" class="d-flex align-center" slot="content">
			<main-container centered>
				<ValidationObserver ref="observer" v-slot="{ failed }">
					<material-card class="px-5 py-3" max-width="400" color="white">
						<v-img :src="$appOptions.systemLogo()" slot="image" class="py-5" contain>
							<template v-slot:placeholder>
								<v-sheet>
									<v-skeleton-loader type="image"></v-skeleton-loader>
								</v-sheet>
							</template>
						</v-img>
						<div slot="after-heading">
							{{ $t("user.login_title") }}
						</div>
						<v-form>
							<v-row dense class="justify-center">
								<v-col cols="12" xs="12">
									<ValidationProvider vid="email" :name="'Email'" rules="required|email" v-slot="{ errors, field }">
										<v-text-field @keyup.enter="login" :autofocus="$appOptions.canAutofocus()" type="text" prepend-icon="fas fa-user" label="Email" v-model="user.email" name="email" :error-messages="errors" @change="resetValidator()"></v-text-field>
									</ValidationProvider>
								</v-col>
								<v-col cols="12" xs="12">
									<ValidationProvider vid="password" :name="'Password'" rules="required|min:6" v-slot="{ errors, field }">
										<v-text-field @keyup.enter="login" ref="password" id="password" prepend-icon="fas fa-unlock-alt" name="password" :error-messages="errors" label="Password" type="password" v-model="user.password" @change="resetValidator()"></v-text-field>
									</ValidationProvider>
								</v-col>
								<v-col cols="12" xs="12" sm="6">
									<v-checkbox class="mt-0" hide-details label="Ricordami" v-model="user.remember"></v-checkbox>
								</v-col>
								<v-col cols="12" xs="12" sm="6">
									<router-link :to="{ name: 'askreset' }" color="secondary">Password dimenticata?</router-link>
								</v-col>
							</v-row>
						</v-form>
						<template slot="actions">
							<v-col cols="6" xs="6">
								<action-button color="success" @click="login" block :loading="is_authloading" :disabled="failed" :text="$t('user.login')"></action-button>
							</v-col>
						</template>
					</material-card>
				</ValidationObserver>
			</main-container>
		</v-responsive>
	</auth-layout>
</template>

<script>
export default {
	data: () => ({
		user: {
			email: "",
			password: "",
			device_name: "Vue WebApp",
			remember: false,
		},
	}),
	computed: {
		is_authloading() {
			return this.$store.getters.is_authloading;
		},
		isAuthenticated() {
			return this.$store.getters.isAuthenticated;
		},
		apierrors() {
			return this.$store.getters.getApiErrors;
		},
	},
	methods: {
		resetValidator() {
			this.$refs.observer.reset();
		},
		askReset() {
			this.$router.push({
				name: "askreset",
			});
		},
		login: function () {
			const self = this;
			this.$refs.observer.validate().then((isValid) => {
				if (isValid == true) {
					this.$store.dispatch("login", this.user).then(() => {
						if (this.isAuthenticated) {
							self.$router.push({
								path: "/dashboard",
							});
						}
					});
				}
			});
		},
	},
	watch: {
		"user.email": {
			handler: function (val) {
				if (val.indexOf(" ") != -1) {
					this.user.email = val.replace(/\s/, "");
				}
			},
		},
		apierrors: {
			handler: function (val) {
				this.$functions.ApiErrorsWatcher(val, this.$refs.observer);
			},
			deep: true,
		},
	},
};
</script>
